import axios from '@util/axios'

class GlobalUMRs {
  async getItems(params = {}) {
    return await axios({
      url: '/lincoln/global-umr/list/',
      params: params,
      responseType: !!params.download ? 'blob' : 'json'
    })
  }

  async updateItems(email, payload) {
    return await axios({
      url: '/lincoln/global-umr/update/',
      method: 'PUT',
      data: {
        user_email: email,
        data: payload
      }
    })
  }
}

export default new GlobalUMRs()
